import { Component } from '@angular/core';
import { UserConfigsService } from '@services/user-configs.service';
import { BaseComponent } from '../../base.component';
import { Router } from '@angular/router';

@Component({
    selector: 'lex-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent extends BaseComponent {
	constructor(
		public userConfigService: UserConfigsService,
		private router: Router
	) {
		super();

	}

	public isSectionActive(route: string) {
		return this.router.isActive(route, {
			paths: 'subset',
			queryParams: 'subset',
			fragment: 'ignored',
			matrixParams: 'ignored'
		});
	}
}
